import { useState } from "react";
import { api } from "../api.ts";

export function Login({ onDone }: { onDone: () => void }) {
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  return (
    <div className="login">
      <span className="wordmark">sekani</span>
      <p className="eyebrow">Back-office</p>
      <form onSubmit={async (e) => {
        e.preventDefault(); setBusy(true); setErr(null);
        try { await api("/auth/sign-in/email", { body: f }); onDone(); } catch { setErr("Identifiants incorrects."); } finally { setBusy(false); }
      }}>
        <label className="field"><span>E-mail</span><input type="email" autoComplete="username" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} /></label>
        <label className="field"><span>Mot de passe</span><input type="password" autoComplete="current-password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} /></label>
        {err && <p className="err small" role="alert">{err}</p>}
        <button className="btn solid" disabled={busy}>Se connecter</button>
      </form>
    </div>
  );
}
